import {RoutingModel} from "../../common/models/routing";
import RouteSwitch from "../../helpers/routeSwitch";
import LocationsList from "../components/locations/locationsList/locationsList";
import {UserRoles} from "../../helpers/userRoles";
import AddLocation from "../components/locations/addLocation/addLocation";
import ModifyLocation from "../components/locations/modifyLocation/modifyLocation";
import RouteList from "../components/topologyRoutes/routeList/routeList";
import AddRoute from "../components/topologyRoutes/addRoute/addRoute";
import ModifyRoute from "../components/topologyRoutes/modifyRoute/modifyRoute";

enum locationsRoutingAddress {
    locations = "/topology/location",
    list = "/topology/location/list",
    add = "/topology/location/add-location",
    modify = "/topology/location/modify-location"
}

enum routesRoutingAddress {
    routes = "/topology/routes",
    list = "/topology/routes/list",
    add = "/topology/routes/add-route",
    modify = "/topology/routes/modify-route"
}

export const topologyRoutingAddress = {
    locations: locationsRoutingAddress,
    routes: routesRoutingAddress
};

export const topologyRoutes: RoutingModel[] = [
    {
        path: topologyRoutingAddress.locations.locations,
        component: RouteSwitch,
        routes: [
            {
                path: topologyRoutingAddress.locations.list,
                component: LocationsList,
                roles: [UserRoles.topologyViewAndModification]
            },
            {
                path: topologyRoutingAddress.locations.add,
                component: AddLocation,
                roles: [UserRoles.topologyViewAndModification]
            },
            {
                path: `${topologyRoutingAddress.locations.modify}/:id`,
                component: ModifyLocation,
                roles: [UserRoles.topologyViewAndModification]
            }
        ]
    },
    {
        path: topologyRoutingAddress.routes.routes,
        component: RouteSwitch,
        routes: [
            {
                path: topologyRoutingAddress.routes.list,
                component: RouteList,
                roles: [UserRoles.topologyViewAndModification]
            },
            {
                path: topologyRoutingAddress.routes.add,
                component: AddRoute,
                roles: [UserRoles.topologyViewAndModification]
            },
            {
                path: `${topologyRoutingAddress.routes.modify}/:id`,
                component: ModifyRoute,
                roles: [UserRoles.topologyViewAndModification]
            }
        ]
    }
];
